import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import VueAxios from 'vue-axios'
import { dispatch } from 'vuex-pathify'
Vue.use(VueAxios, axios)

// Vuex
// import { get, sync } from 'vuex-pathify'

axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://iroda.cumuluslog.com:8088'
axios.defaults.baseURL = process.env.VUE_APP_API_URL // NODE_ENV === 'development' ? 'http://localhost:8088' : 'https://cumuluslog.herokuapp.com'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

axios.interceptors.request.use(
  (config) => {
    if (config.url !== '/api/check') {
      store.set('app/loading', true)
    }
    const token = localStorage.getItem('access_token')

    if (token) {
      config.headers.Authorization = `Bearer ${ token }`
    }

    return config
  },

  (error) => {
    store.set('app/loading', false)
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if (response.config.url !== '/api/check') {
    store.set('app/loading', false)
  }
  return response
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  // store.set(, false)
  if (!error.response) {
    dispatch('alert/setSnackbar', { text: 'network_error', type: 'error' })
  } else if (error.response.status === 401 || error.response.status === 419) {
    // dispatch('alert/setSnackbar', { text: 'unauthorized', type: 'error' })
    dispatch('auth/logout')
  } else if (error.response.status === 403) {
    console.log(error.response)
    if (error.response.data.error === 'invalid_credentials') {
      dispatch('alert/setSnackbar', { text: 'invalid_credentials', type: 'error' })
    } else {
      dispatch('alert/setSnackbar', { text: 'missing_permissions', type: 'error' })
    }
  }
  store.set('app/loading', false)
  return Promise.reject(error)
})

export default axios
